// src/pages/Users/Techniques/components/TechniquesToolbar.jsx
import React from "react";
import { FaHeart, FaShareAlt, FaTimes } from "react-icons/fa";

export default function TechniquesToolbar({
  dynamicOptions,
  ui,
  onChange,
  debouncedSearch,
  setDebouncedSearch,
  onReset,
  onShare,
  shareCopied,
}) {
  return (
    <div className="flex flex-col gap-3">
      {/* Ligne 1 : recherche + icônes actions */}
      <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
        <input
          type="text"
          placeholder="Rechercher (nom, traduction, famille)…"
          className="input input-bordered w-full dark:bg-slate-200 dark:text-black"
          value={debouncedSearch}
          onChange={(e) => setDebouncedSearch(e.target.value)}
        />

        <div className="flex items-center gap-2">
          {/* Favoris */}
          <button
            type="button"
            onClick={() => onChange({ showFav: !ui.showFav })}
            title={ui.showFav ? "Afficher toutes les techniques" : "Afficher uniquement mes favoris"}
            aria-label="Basculer favoris"
            className={`w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
              focus:outline-none focus:ring-2 focus:ring-violet-400
              hover:scale-105 active:scale-95
              ${
                ui.showFav
                  ? "bg-red-50 ring-red-200 text-red-500 dark:bg-red-900/20 dark:ring-red-800"
                  : "bg-slate-100 ring-slate-200 text-slate-500 dark:bg-slate-800 dark:ring-slate-700"
              }`}
          >
            <FaHeart className="text-lg" />
          </button>

          {/* Partager */}
          <button
            type="button"
            onClick={onShare}
            title={shareCopied ? "Lien copié !" : "Copier un lien partageable"}
            aria-label="Partager"
            className={`w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
              focus:outline-none focus:ring-2 focus:ring-violet-400
              hover:scale-105 active:scale-95
              ${
                shareCopied
                  ? "bg-emerald-50 ring-emerald-200 text-emerald-600 dark:bg-emerald-900/20 dark:ring-emerald-800"
                  : "bg-slate-100 ring-slate-200 text-slate-500 dark:bg-slate-800 dark:ring-slate-700"
              }`}
          >
            <FaShareAlt className={`text-lg ${shareCopied ? "animate-pulse" : ""}`} />
          </button>

          {/* Reset */}
          <button
            type="button"
            onClick={onReset}
            title="Réinitialiser tous les filtres"
            aria-label="Reset filtres"
            className="w-10 h-10 grid place-items-center rounded-xl ring-1 transition transform
              focus:outline-none focus:ring-2 focus:ring-violet-400
              hover:scale-105 active:scale-95
              bg-slate-100 ring-slate-200 text-slate-500 dark:bg-slate-800 dark:ring-slate-700"
          >
            <FaTimes className="text-lg" />
          </button>
        </div>
      </div>

      {/* Ligne 2 : filtres */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        <select
          className="select select-bordered w-full dark:bg-slate-200 dark:text-black"
          value={ui.grade}
          onChange={(e) => onChange({ grade: e.target.value })}
        >
          {dynamicOptions.grades.map((g) => (
            <option key={g} value={g}>
              {g}
            </option>
          ))}
        </select>

        <select
          className="select select-bordered w-full dark:bg-slate-200 dark:text-black"
          value={ui.family}
          onChange={(e) => onChange({ family: e.target.value })}
        >
          {dynamicOptions.families.map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </select>

        <select
          className="select select-bordered w-full dark:bg-slate-200 dark:text-black"
          value={ui.uv2}
          onChange={(e) => onChange({ uv2: e.target.value })}
        >
          {dynamicOptions.uv2.map((u) => (
            <option key={u} value={u}>
              {u === "Toutes les fiches" ? "Toutes les fiches UV2" : u}
            </option>
          ))}
        </select>

        <div className="flex items-center">
          <select
            className="select select-bordered w-full dark:bg-slate-200 dark:text-black"
            value={ui.sort}
            onChange={(e) => onChange({ sort: e.target.value })}
          >
            <option value="beltFamily">Ceinture ▸ Famille ▸ Nom</option>
            <option value="alpha">Tri alphabétique</option>
            <option value="grade">Tri par ceinture</option>
            <option value="family">Tri par famille</option>
          </select>
        </div>
      </div>
    </div>
  );
}
